import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react'; // ضفنا أيقونات التنقل
import toast from 'react-hot-toast';

const SafetyPlanList = () => {
  const [plans, setPlans] = useState([]); // دي هتفضل المصفوفة الفعلية
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 }); // لتخزين معلومات الصفحات
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      // 🎯 نبعت الصفحة والبحث للباكيند
      const res = await axios.get(`/api/safety-plans?page=${page}&limit=20&search=${searchTerm}`);
      
      // 🎯 التعديل الجوهري: نسحب الداتا من res.data.data
      setPlans(res.data.data || []); 
      setPagination({
        total: res.data.total,
        page: res.data.page,
        pages: res.data.pages
      });
    } catch (err) {
      toast.error("Failed to load Safety Plans");
      setPlans([]); // تأمين لو ضرب إيرور
    } finally {
      setLoading(false);
    }
  };

  // 🎯 استدعاء الداتا لما البحث يتغير أو الصفحة تتغير
  useEffect(() => {
    fetchData(1); 
  }, [searchTerm]);

  const filteredData = useMemo(() => {
    // تأمين إضافي: لو plans مش مصفوفة لأي سبب، ارجع مصفوفة فاضية
    if (!Array.isArray(plans)) return [];
    return plans; // الفلترة بقت تحصل في السيرفر خلاص
  }, [plans]);

  return (
    <div className="flex flex-col h-full bg-[#f3f4f6] text-[11px] font-sans">
      {/* Header - نفس الكود بتاعك */}
      <div className="bg-white p-3 border-b shadow-sm space-y-3">
        <div className="flex justify-between items-center">
          <h2 className="text-[#005495] font-black italic uppercase text-lg flex items-center gap-2">
            <ShieldCheck size={20} /> Safety Plans
          </h2>
          <div className="flex gap-4">
            <div className="relative">
              <Search className="absolute left-3 top-2 text-gray-400" size={14} />
              <input 
                className="pl-9 pr-4 py-1.5 border border-gray-300 w-80 outline-none rounded-sm font-bold" 
                placeholder="Search Plans..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <button onClick={() => navigate('/safety/new')} className="bg-[#3c70a4] text-white px-6 py-2 rounded-sm font-bold flex items-center gap-2 hover:bg-[#1a3353] shadow-md">
              <Plus size={16} /> New Plan
            </button>
          </div>
        </div>
      </div>

      {/* Table Area */}
      <div className="flex-1 overflow-auto p-4">
        <div className="bg-white border shadow-sm">
          <table className="w-full text-left">
            <thead className="bg-[#f9fafb] border-b text-gray-400 font-bold uppercase sticky top-0">
              <tr>
                <th className="p-2 border-r">Plan Num</th>
                <th className="p-2 border-r">Description</th>
                <th className="p-2 border-r text-center">Status</th>
                <th className="p-2 text-center">Site</th>                
              </tr>
            </thead>
            <tbody>
              {loading ? (
                 <tr><td colSpan="4" className="p-10 text-center text-gray-400 italic font-bold">Loading Data...</td></tr>
              ) : filteredData.map((plan, i) => (
                <tr key={i} className="border-b hover:bg-blue-50 cursor-pointer" onClick={() => navigate(`/safety/${plan.safetypnum}`)}>
                  <td className="p-2.5 border-r font-black text-blue-900">{plan.safetypnum}</td>
                  <td className="p-2.5 border-r text-gray-600 font-semibold">{plan.description}</td>
                  <td className="p-2.5 border-r text-center">
                    <span className={`px-2 py-0.5 rounded-sm font-black ${plan.status === 'ACTIVE' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {plan.status }
                    </span>
                  </td>
                  <td className="p-2.5 text-center text-gray-500">{plan.siteid}</td>                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* 🎯 Pagination UI - الإضافة الفاخرة */}
        <div className="mt-4 flex justify-between items-center bg-white p-2 border rounded shadow-sm font-bold text-gray-500">
          <div>Total Records: <span className="text-blue-900">{pagination.total}</span></div>
          <div className="flex items-center gap-4">
            <button 
              disabled={pagination.page === 1}
              onClick={() => fetchData(pagination.page - 1)}
              className="p-1 disabled:opacity-30 hover:bg-gray-100 rounded"
            >
              <ChevronLeft size={16} />
            </button>
            <span>Page {pagination.page} of {pagination.pages}</span>
            <button 
              disabled={pagination.page === pagination.pages}
              onClick={() => fetchData(pagination.page + 1)}
              className="p-1 disabled:opacity-30 hover:bg-gray-100 rounded"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyPlanList;